function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".arrowRighta{fill:#afafaf;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1764.63 -1469)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1764.63 1469)"
}, /*#__PURE__*/React.createElement("path", {
  className: "arrowrighta",
  d: "M1771.249,1476.521a.9.9,0,0,1-.637-.264l-5.718-5.718a.9.9,0,0,1,1.275-1.275l5.718,5.718a.9.9,0,0,1-.637,1.539Z",
  transform: "translate(-1764.63 -1469)"
}), /*#__PURE__*/React.createElement("path", {
  className: "arrowrighta",
  d: "M1765.583,1495.531a.9.9,0,0,1-.637-1.539l5.7-5.7a.9.9,0,1,1,1.275,1.275l-5.7,5.7A.9.9,0,0,1,1765.583,1495.531Z",
  transform: "translate(-1764.666 -1482.308)"
})));

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7.521,
    height: 13.223,
    viewBox: "0 0 7.521 13.223",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowRight.5fe49570.svg";
export { ForwardRef as ReactComponent };